import { BorderRadiusCorners, Box, Text } from '@factorialco/deprecated-design-system'

import ColorBlock from './ColorBlock'

interface Props {
  defaultShiftTitle: string
  color: string
  range: string
  timeRange: string
}

const ShiftBlock = ({ defaultShiftTitle, color, range, timeRange }: Props) => {
  const borderRadius: BorderRadiusCorners = {
    all: 'abs008',
  }

  return (
    <>
      <Box
        flexDirection="row"
        border={{
          all: {
            width: 's2',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={borderRadius}
        padding="s16"
        width="full"
      >
        <Box flexDirection="row" gap="s16" alignItems="center">
          <Box flexDirection="column">
            <ColorBlock color={color ? color : 'grey400'} />
          </Box>
          <Box flexDirection="column" gap="s8">
            <Text size="300" weight="normal" color="grey1000">
              {defaultShiftTitle}
            </Text>
            <Text size="500" weight="medium" color="grey1000">
              {timeRange}
            </Text>
            <Text size="300" weight="normal" color="grey1000">
              {range}
            </Text>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default ShiftBlock
